import React from 'react';
import { useAuth } from '@clerk/clerk-react';
import { LoadingFallback } from '../common/LoadingIndicators';

interface AuthGateProps {
  children: React.ReactNode;
  fallback: React.ReactNode;
}

/**
 * AuthGate - A component that conditionally renders content based on authentication state
 * 
 * @param children - Content to render when user is authenticated
 * @param fallback - Content to render when user is not authenticated
 */
const AuthGate: React.FC<AuthGateProps> = ({ children, fallback }) => {
  const { isSignedIn, isLoaded } = useAuth();
  
  // Show loading state while Clerk is initializing
  if (!isLoaded) {
    return <LoadingFallback />;
  }
  
  // Render children if signed in, fallback if not
  return isSignedIn ? <>{children}</> : <>{fallback}</>;
};

export default AuthGate;
